import "./navbar.scss";
import { Link } from "react-router-dom";

const Navbar = () => {
  return (
    <>
      <section className="main-navbar">
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-12 p-0 m-auto">
              <nav class="navbar navbar-expand-lg">
                <a class="navbar-brand" href="/"><img src="\logo.svg" alt="img" className="img-fluid" /></a>
                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                  <span ><i class="fas fa-bars"></i></span>
                </button>

                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                  <ul class="navbar-nav mr-auto">
                    <li class="nav-item active">
                      <a class="nav-link active" href="#">DAO <span class="sr-only">(current)</span></a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" href="#">Docs</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" href="#">Discourse</a>
                    </li>
                  </ul>
                  <button className="btn-wallet" data-toggle="modal" data-target="#exampleModalwallet">Connect Wallet</button>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </section>
      <div className='connectwalletmodal'>
        <div class="modal fade" id="exampleModalwallet" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">

              <div class="modal-body">
                <div className='main-heading'>
                  <h3>Connect Wallet</h3>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <img src='\assets\cross-btn.svg' className='img-fluid crossimg' />
                  </button>
                </div>
                <div className='Submitproposal'>
                  <div className="iconimages">
                    <div className="leftimage" >
                      <img src="\assets\metamask 2.svg" className="img-fluid" />
                      <p>Metamask</p>
                    </div>
                    <div className="leftimage">
                      <img src="\assets\Group.svg" className="img-fluid" />
                      <p>WalletConnect</p>
                    </div>
                  </div>

                </div>
                
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
